import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumStockAdjustmentStatus implements BaseEnumType {
  private static allValues: EnumStockAdjustmentStatus[] = []; // make sure this is top-most
  
  public static none = new EnumStockAdjustmentStatus(0, "None", "enum_stock_adjustment_status_none");
  public static open = new EnumStockAdjustmentStatus(1, "Open", "enum_stock_adjustment_status_open");
  public static cancelled = new EnumStockAdjustmentStatus(3, "Cancelled", "enum_stock_adjustment_status_cancelled");
  public static complete = new EnumStockAdjustmentStatus(4, "Complete", "enum_stock_adjustment_status_complete");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumStockAdjustmentStatus.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumStockAdjustmentStatus.none; }
  public isOpen() { return this === EnumStockAdjustmentStatus.open; }
  public isCancelled() { return this === EnumStockAdjustmentStatus.cancelled; }
  public isComplete() { return this === EnumStockAdjustmentStatus.complete; }

  public static getValues(): readonly EnumStockAdjustmentStatus[] {
    return EnumStockAdjustmentStatus.allValues;
  }

  public static getValuesExcept0(): readonly EnumStockAdjustmentStatus[] {
    return EnumStockAdjustmentStatus.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumStockAdjustmentStatus {
    const found = EnumStockAdjustmentStatus.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumStockAdjustmentStatus - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumStockAdjustmentStatus): EnumStockAdjustmentStatus {
    const found = name ? EnumStockAdjustmentStatus.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumStockAdjustmentStatus - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumStockAdjustmentStatus>): boolean {
    return this.key === other?.key;
  }
}